<script>
import {useRouter} from "vue-router";
import EodPage from "@components/reports/EOD/EODPage.vue"
import Mixin from "@utilities/mixin.js";
import ReportMixin from "@components/reports/mixin.js";
import STAT from "@components/reports/STAT.vue";
import KpiReport from "@components/reports/KPI/KPIReport.vue";

export default {
  name: "ReportsMain",
  mixins: [Mixin, ReportMixin],
  components: {STAT, KPI: KpiReport, EOD: EodPage},
  setup() {
    const router = useRouter(); // Create router instance
    return {router};
  },
  data() {
    return {
      month: new Date(),
      selectedShop: null,
      reportsPage: [true, false, false],
      selectedTech: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isManager() {
      return this.user
          && Object.entries(this.user).length !== 0
          && (this.user['allcaps']['sb_manager_role']
              || this.user['allcaps']['administrator'])
    },
    onEOD() {
      return this.$route.name === 'manager-reports-eod';
    },
    onKPI() {
      return this.$route.name === 'manager-reports-kpi';
    },
    onSTAT() {
      return this.$route.name === 'manager-reports-stat';
    },
    transactions() {
      return this.$store.state.transactions;
    },
    showSelectors() {
      return !this.onEOD;
    },
    severityZero() {
      return this.onSTAT ? 'primary' : 'secondary';
    },
    severityOne() {
      return this.onKPI ? 'primary' : 'secondary';
    },
    severityTwo() {
      return this.onEOD ? 'primary' : 'secondary';
    },
  },
  methods: {
    switchTo(index) {
      this.reportsPage = this.reportsPage.map((page, i) => i === index);
    },
    setUserTech() {
      let currentUserTech = {id: 0};
      if (this.user && this.techs.length > 0) {
        currentUserTech = this.techs.find(i => parseInt(this.user.ID) === i.user_id);
      }
      if (!currentUserTech) {
        throw new Error("User is not registered as a technician.");
      }
      this.selectedTech = currentUserTech.id;
    },
  },
  created() {
    this.getShops();
    this.getTechs();
  },
  watch: {
    month: {
      handler(newMonth) {
        if (this.month) {
          const dates = this.getMonthDates(newMonth);
          this.$store.commit('setDates', dates);
        }
      },
      immediate: true,
    },
    selectedTech: {
      handler(newTech) {
        this.$store.commit('setTechId', newTech);
      },
      immediate: true,
    },
    selectedShop: {
      handler(newShop) {
        this.$store.commit('setSelectedShop', newShop);
      },
      immediate: true,
    },
    user: {
      handler(newUser) {
        if (newUser && !this.isManager && Object.entries(newUser).length !== 0) {
          this.setUserTech();
        }
      },
      immediate: true,
    }
  }
}
</script>

<template>
  <div class="flex flex-col gap-0 w-full">
    <Toolbar class="mt-0">
      <template #start>
        <Button v-if="isManager"
                @click="router.push('/reports/stat')"
                :severity="severityZero"
                class="me-2 sleek-input"
                label="STAT"/>
        <Button
            @click="router.push('/reports/kpi')"
            :severity="severityOne"
            class="me-2 sleek-input"
            label="KPIs"/>
        <Button
            @click="router.push('/reports/eod')"
            :severity="severityTwo"
            class="me-2 sleek-input"
            label="EODs"/>
        <DatePicker class="me-2" v-model="month" showIcon view="month" fluid iconDisplay="input" dateFormat="MM/yy"/>
        <Select v-if="showSelectors"
                v-model="selectedShop"
                :options="[{ id: null, name: 'All Shops' }, ...shops]"
                class="sleek-input me-2"
                showClear
                filter
                optionLabel="name"
                optionValue="id"
                placeholder="All Shops"/>
        <Select v-if="showSelectors && isManager"
                v-model="selectedTech"
                :options="[{ id: null, name: 'All Techs' }, ...techs]"
                class="sleek-input me-2"
                showClear
                filter
                optionLabel="name"
                optionValue="id"
                placeholder="All Techs"/>
      </template>
    </Toolbar>
    <router-view></router-view>
  </div>
</template>

<style>
.custom-table td th {
  background-color: #FFFFFF !important;
}

td.text-truncate,
th.text-truncate {
  height: 35px !important;
  text-align: center;
  vertical-align: middle;
  padding: 5px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 75px;
}

:deep(.sleek-input) {
  text-align: center;
  padding: 0 3px;
  line-height: 1;
  height: 30px;
}
</style>